import { STATUS } from "./const";

export const dialog = {
    msg(text, position = 'middle') {
        const elID = 'dialog-msg';
        if (document.getElementById(elID)) {
            return;
        }
        let el = document.createElement('div');
        el.id = elID;
        el.className = position;
        el.innerHTML = text;
        document.body.appendChild(el);
        setTimeout(() => {
            el.parentNode.removeChild(el);
        }, 2000);
    }
};

// 获取用户状态
export function getPlayerStatus(status) {
    status = parseInt(status);
    let str = '';
    switch (status) {
        case STATUS.outline:
            str = '离线';
            break;
        case STATUS.online:
            str = '在线';
            break;
        case STATUS.waiting:
            str = '挂机';
            break;
        default:
            str = '未知';
    }
    return str;
}

// 返回发言的html
export const getSayHTML = {
    applyCaptain(text) {
        return `<p style="font-size: 16px;color: #ff0404;font-weight: bold;text-align: center;" class="big2small">${text}</p>`;
    },
    tactic(obj) {
        const selectedArr = obj.rightSelectedText.split('-');
        const replyText = selectedArr[1];
        const tacticText = selectedArr[0];
        const content = `
                  <p class="tactic" style="font-size: 16px;">
                        <span style="color: #c5c5c6;">${obj.title}: </span>
                        <span style="color: #7D4228;">${obj.menStr}</span>
                        <span style="color: #000">${tacticText}</span> - 
                        <span style="color: #838383">${replyText}</span>
                  </p>
        `;
        return content;
    },
    normal(text) {
        let str = '';
        if (text) {
            str =  `<p style="color: #000;font-size: 16px;">${text}</p>`;
        }
        return str;
    }
}

/**
 * 不记录该url历史记录
 * @param url
 */
export function fnUrlReplace (url) {
    if (!url) {
        return;
    }
    if (history.replaceState) {
        history.replaceState(null, document.title, url);
        location.replace('');
    } else {
        location.replace(url);
    }
}
